<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-06-06 16:50:58
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-12 16:29:17
-->
<template>
	<span class="yx-button-group pos-rela" :style="`padding-left: ${paddingLeft}px;padding-right:${paddingRight}px`">
		<slot></slot>
		<div class="split-line pos-abso" :style="`height: ${lineHeight}px`"></div>
	</span>
</template>
<script>
export default {
	name: 'ButtonGroup',
	props: {
		lineHeight: {
			type: [String, Number],
			default: 16,
		},
		paddingLeft: {
			type: [String, Number],
			default: 12,
		},
		paddingRight: {
			type: [String, Number],
			default: 12,
		},
	},
};
</script>
<style lang="less">
.yx-button-group {
	display: flex;
	align-items: center;
	.split-line {
		display: none;
		left: 0;
		width: 1px;
		background-color: @border-color-base;
	}
	& + & {
		.split-line {
			display: block;
		}
	}
}
</style>
